import React, { SyntheticEvent } from 'react';
import { Icon } from '@fikasio/react-ui-components';

const DropdownToggle = React.forwardRef(({ onClick }: { onClick: (e: SyntheticEvent) => void; }, ref: any) => (
  <div
    onClick={e => {
      e.preventDefault();
      onClick(e);
    }}
    ref={ref}
    style={{
      color: 'black',
      cursor: 'pointer',
      textDecoration: 'none',
    }}
  >
    <Icon
      name="ellipsis"
      size="1x"
    />
  </div>
));

export default DropdownToggle;
